import { render, staticRenderFns } from "./CompanyGroupingDialog.vue?vue&type=template&id=48216993&scoped=true&"
import script from "./CompanyGroupingDialog.vue?vue&type=script&lang=js&"
export * from "./CompanyGroupingDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48216993",
  null
  
)

export default component.exports